import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { apiFetch } from "@/lib/api";
import { supabase } from "@/lib/supabaseClient";

const BrandingContext = createContext(null);

const EMPTY = { assets: {}, settings: { header_height: 36, mobile_height: 28, product_label: "ContentOS" }, org_name: "Nirvana", short_name: "Nirvana", tagline: "", is_admin: false };

function applyFavicon(url) {
  if (!url) return;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
}

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const b = await apiFetch(session ? "/branding" : "/branding/public");
      setBranding(b);
      applyFavicon(b?.assets?.favicon?.url);
      if (b?.org_name) document.title = `${b.org_name} · ContentOS`;
    } catch { /* keep defaults */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [user, refresh]);

  const value = { ...branding, loading, refresh };
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext) || EMPTY;
